const whiteList = ['/login', '/', '/home', '/usercenter', '/message', '/cart', '/category', '/setting', '/search-middle', '/goods', '/help', '/search', '/afterSale']
export default whiteList
